import axios from 'axios';
import {config} from '../config'

var axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

export default axiosInstance;
